import type {UUID} from 'typings/portaro.be.types';
import type {StateProvider} from '@uirouter/angularjs';
import type {ToastMessageService} from 'shared/components/kp-toast-messages/toast-message.service';
import type {FileService} from 'src/features/file/file.service';
import type WalkerService from 'shared/services/walker.service';
import type RecordDataService from 'src/features/record/record.data-service';
import {KpSvelteComponentWrapperComponent} from 'core/kp-svelte-component-wrapper/kp-svelte-component-wrapper.component';
import {exists} from 'shared/utils/custom-utils';

/*@ngInject*/
export function sutorReportsProcessingRoutes($stateProvider: StateProvider) {
    let reportsProcessingModule: { default: any; };

    $stateProvider
        .state({
            name: 'reports-processing',
            url: '/reports/processing/:id',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => reportsProcessingModule.default,

                /*@ngInject*/
                props: async (
                    recordDataService: RecordDataService,
                    fileService: FileService,
                    toastMessageService: ToastMessageService,
                    walker: WalkerService,
                    $stateParams: { id: UUID } // Injects URL parameters
                ) => {
                    try {
                        const record = await recordDataService.getById($stateParams.id);

                        if (!exists(record) || !exists(record.directoryId)) {
                            toastMessageService.showError('Neplatný záznam!');
                            await walker.newSpaPage('reports');
                            return;
                        }

                        const allFiles = await fileService.getFilesByDirectory(record.directoryId);
                        if (allFiles.length === 0) {
                            toastMessageService.showError('Záznam neobsahuje žádný soubor!');
                            await walker.newSpaPage('reports');
                            return;
                        }

                        return {
                            file: allFiles[0],
                            record
                        };
                    } catch (e) {
                        toastMessageService.showError(`Nastala chyba: ${e.message}`);
                        await walker.newSpaPage('reports');
                        return;
                    }
                }
            },
            lazyLoad: async () => {
                reportsProcessingModule = await import(/* webpackChunkName: "reportsProcessing" */ '../SutorReportsProcessingPage.svelte');
                return null;
            }
        });
}